import React, { useEffect, useRef, useState } from 'react';
import { Checkbox, Form } from 'antd';
import { CheckSquareOutlined, InfoCircleOutlined } from '@ant-design/icons';
import ReactDOM from 'react-dom';
import { t } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";

export default (formPlugin, namespace) => {
    return {
        Renderer: (props) => {

            let containerRef = useRef(null)
            const [listField, setlistField] = useState(null)
            useEffect(() => {
                setlistField(props.pluginConfig.getListField(containerRef.current))
            }, [])

            if (props.remove) {
                formPlugin.onAddFormPlugin(props, props.nodeId, props.pluginConfig.id)
            }

            if ((props.isPreviewMode || props.readOnly) && !props.data.fieldKey) {
                return null
            }

            const { data } = props

            let rules = [{ required: data.required || false, message: t`Ce champ est obligatoire` }]

            let tooltip = null
            if (data.tooltip) {
                tooltip = {
                    title: data.tooltip,
                    icon: <InfoCircleOutlined />,
                }
            }

            const listFieldProps = listField ? listField : null
            const finalName = "[CHECKBOX]_" + data.fieldKey

            return (
                <div ref={(ref) => containerRef.current = ref}>
                    <Form.Item
                        {...listFieldProps}
                        name={listField ? [listField.name, finalName].flat() : finalName}
                        rules={rules}
                        tooltip={tooltip}
                    >
                        <FormCheckbox required={data.required}>
                            <Checkbox size={"middle"}>{data.label}</Checkbox>
                        </FormCheckbox>
                    </Form.Item>
                </div>
            )
        },
        namespace: namespace,
        id: 'form-checkbox' + namespace,
        title: t`Case à cocher`,
        description: t`Élément de formulaire utilisable.`,
        icon: <CheckSquareOutlined />,
        iconColor: "#F39C12",
        version: 1,
        getListField: (containerRef) => {
            const listField = ReactDOM.findDOMNode(containerRef)?.closest(".form-field")?.dataset.field
            if (listField) {
                return JSON.parse(listField)
            }
            return null
        },
        controls: {
            type: 'autoform',
            schema: {
                properties: {
                    required: {
                        type: 'boolean',
                        uniforms: {
                            label: t`Obligatoire`,
                        }
                    },
                    fieldKey: {
                        type: 'string',
                        uniforms: {
                            required: true,
                            label: t`Identifiant`,
                            placeholder: t`Identifiant du champ`,
                        }
                    },
                    label: {
                        type: 'string',
                        uniforms: {
                            required: true,
                            label: t`Étiquette`,
                            placeholder: t`Libellé`,
                        }
                    },
                    tooltip: {
                        type: 'string',
                        uniforms: {
                            label: t`Message d'aide`,
                            placeholder: t`Message d'aide`,
                            multiline: true,
                            rows: 2,
                        }
                    },
                }
            },
        },
    }
}

export function FormCheckbox({ required, value, onChange, children }) {
    const formatChange = (e) => {
        const v = e.target.checked
        if (required) {
            if (v !== true) {
                return undefined
            }
            return true
        }
        return v || false
    }

    return React.Children.map(children, child => {
        if (React.isValidElement(child)) {
            return React.cloneElement(child, { checked: value, onChange: (e) => onChange(formatChange(e)) });
        }
        return child;
    });
}
